export const trimTextToLength = (text, length = 200) => {
  if (!text) return;
  const excerpt = text.substring(0, length);
  return excerpt.length === length ? excerpt + "..." : excerpt;
};

/**
 * Callers build id lists like
 * `[...(selectedAccount?.childExternalIds || []), selectedAccount?.account?.externalId]`,
 * which is `[undefined]` before an account is selected. Dropping empty entries
 * stops us emitting `?externalIds=` (the API answers 401) or appending a
 * value-less duplicate alongside real ids.
 */
export const compactList = (arr) =>
  (arr || []).filter(
    (value) => value !== null && value !== undefined && `${value}`.trim() !== ""
  );

export const buildQueryStringList = (name, arr) => {
  const values = compactList(arr);
  return values.length > 0 ? `?${name}=${values.join(`&${name}=`)}` : "";
};

export const addQueryStringList = (name, arr) => {
    const values = compactList(arr);
    return values.length > 0 ? `&${name}=${values.join(`&${name}=`)}` : "";
};

export const capitaliseFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

export const isEmpty = (string) =>
    string.trim().length === 0;

const stringUtils = {
  trimTextToLength,
  compactList,
  buildQueryStringList,
  addQueryStringList,
  isEmpty,
};

export default stringUtils;
